import React, { useState } from "react";
import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  FormLabel,
  Grid,
  InputAdornment,
  TextField,
} from "@material-ui/core";

export default function SetTemperature(props) {
  const { key, isLoading = false, handleSubmitModalCommand = () => { }, commandDetails = {} } = props?.globalModal.data || {};

  const [temperatureValue, setTemperatureValue] = useState("");

  const handleChange = (event) => {
    const { value } = event.target;
    const fomrattedValue = value.replace(/[^0-9]/g, "");
    setTemperatureValue(fomrattedValue);
  };

  const handleSubmit = () => {
    const request = { ...commandDetails };
    request.packet[1].temp_set = temperatureValue;
    handleSubmitModalCommand(key, request);
    props.closeModal();
  };

  return (
    <>
      <DialogTitle className="heat_pump_modal_title">
        <Grid item md={12} className="d-flex">
          <h6>Set temperature</h6>
        </Grid>
      </DialogTitle>
      <DialogContent
        dividers
        className="heat_pump_dialog_content heat-modal-content"
      >
        <FormControl variant="outlined" fullWidth>
          <FormLabel>Temperature</FormLabel>
          <TextField
            placeholder="Enter temperature"
            name="temperature"
            type="text"
            variant="outlined"
            value={temperatureValue || ""}
            onChange={handleChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <span className="linecel"></span> °C
                </InputAdornment>
              ),
            }}
          />
          {temperatureValue &&
            (temperatureValue < 27 || temperatureValue > 70) ? (
            <FormHelperText
              style={{
                color: "red",
                textAlign: "left",
                padding: "0px",
                margin: "0px",
              }}
            >
              Temperature should be between 27°C and 70°C
            </FormHelperText>
          ) : null}
        </FormControl>
      </DialogContent>
      <Grid>
        <DialogActions className="heat_pump_dialog_action">
          <Button
            className={`cus-btn-modal-submit ${isLoading[key] || !temperatureValue || temperatureValue < 27 || temperatureValue > 70 ? "disabled" : ""}`}
            onClick={isLoading[key] || !temperatureValue || temperatureValue < 27 || temperatureValue > 70 ? null : handleSubmit}
          >
            {isLoading[key] ? <CircularProgress size={18} color="white" /> : "Submit"}
          </Button>
        </DialogActions>
      </Grid>
    </>
  );
}
